import React from 'react';
import SEO from '../components/SEO';
import { FaUsers, FaShieldAlt, FaAward, FaHeart } from 'react-icons/fa';

const About: React.FC = () => {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: 'About TurboBetto',
    description: 'Learn about TurboBetto and our mission to help UK players find the best casino offers',
    url: 'https://turbobetto.com/about',
  };

  return (
    <>
      <SEO
        title="About Us"
        description="Learn about TurboBetto - your trusted guide to UK casino offers. Our mission, values, and commitment to responsible gambling."
        url="/about"
        schema={schema}
      />

      <div className="pt-24 pb-20 min-h-screen bg-dark-bg">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-4xl md:text-5xl font-bold mb-6 text-center">About TurboBetto</h1>

            <div className="bg-dark-card border border-dark-border rounded-xl p-8 mb-8">
              <h2 className="text-2xl font-bold text-white mb-4">Our Mission</h2>
              <p className="text-gray-300 leading-relaxed mb-4">
                TurboBetto was founded with a simple goal: to help UK players navigate the
                complex world of online casino offers and find the best deals that suit their
                needs. We understand that choosing the right casino can be overwhelming, with
                hundreds of options and countless bonus offers to compare.
              </p>
              <p className="text-gray-300 leading-relaxed">
                Our team of gambling experts spends countless hours reviewing casinos, testing
                bonuses, and analyzing terms and conditions so you don't have to. We provide
                honest, transparent reviews that cut through the marketing hype and give you
                the real information you need to make informed decisions.
              </p>
            </div>

            <div className="grid md:grid-cols-2 gap-6 mb-8">
              <div className="bg-dark-card border border-dark-border rounded-xl p-6">
                <FaUsers className="text-yellow-400 text-4xl mb-4" />
                <h3 className="text-xl font-bold text-white mb-3">Expert Team</h3>
                <p className="text-gray-300 text-sm">
                  Our team consists of experienced gambling professionals, casino reviewers, and
                  bonus analysts who understand the industry inside and out.
                </p>
              </div>

              <div className="bg-dark-card border border-dark-border rounded-xl p-6">
                <FaShieldAlt className="text-yellow-400 text-4xl mb-4" />
                <h3 className="text-xl font-bold text-white mb-3">Trust & Transparency</h3>
                <p className="text-gray-300 text-sm">
                  We maintain complete editorial independence. Our reviews are honest and
                  unbiased, based solely on our testing and analysis.
                </p>
              </div>

              <div className="bg-dark-card border border-dark-border rounded-xl p-6">
                <FaAward className="text-yellow-400 text-4xl mb-4" />
                <h3 className="text-xl font-bold text-white mb-3">Quality First</h3>
                <p className="text-gray-300 text-sm">
                  We only feature casinos that meet our strict quality standards, including
                  proper licensing, fair terms, and excellent player protection.
                </p>
              </div>

              <div className="bg-dark-card border border-dark-border rounded-xl p-6">
                <FaHeart className="text-yellow-400 text-4xl mb-4" />
                <h3 className="text-xl font-bold text-white mb-3">Responsible Gambling</h3>
                <p className="text-gray-300 text-sm">
                  We're committed to promoting responsible gambling and providing resources
                  for players who need help managing their gambling habits.
                </p>
              </div>
            </div>

            <div className="bg-dark-card border border-dark-border rounded-xl p-8">
              <h2 className="text-2xl font-bold text-white mb-4">What We Do</h2>
              <ul className="space-y-3 text-gray-300">
                <li className="flex items-start">
                  <span className="text-yellow-400 mr-3">•</span>
                  <span>
                    Review and test UK-licensed casinos to ensure they meet our quality standards
                  </span>
                </li>
                <li className="flex items-start">
                  <span className="text-yellow-400 mr-3">•</span>
                  <span>
                    Analyze bonus terms and conditions to identify fair and valuable offers
                  </span>
                </li>
                <li className="flex items-start">
                  <span className="text-yellow-400 mr-3">•</span>
                  <span>
                    Compare casinos side-by-side to help you find the best match for your preferences
                  </span>
                </li>
                <li className="flex items-start">
                  <span className="text-yellow-400 mr-3">•</span>
                  <span>
                    Provide educational content about casino bonuses, wagering requirements, and responsible gambling
                  </span>
                </li>
                <li className="flex items-start">
                  <span className="text-yellow-400 mr-3">•</span>
                  <span>
                    Keep our information up-to-date as casinos change their offers and terms
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default About;

